import React, {useState, useRef, useEffect, Fragment} from "react"
import ReactDOM from "react-dom"
import InputLabel from "@material-ui/core/InputLabel"
import NotchedOutline from "@material-ui/core/OutlinedInput/NotchedOutline"


import {makeStyles} from "@material-ui/core/styles"
import Typography from '@material-ui/core/Typography'

import Box from '@material-ui/core/Box'

// Custom Style
import {redColor, grayColor} from '../../styles/jss/cmsMainStyle'
import legendStyle from "../../styles/jss/components/legend/legendStyle"


const useStyles = makeStyles(theme => legendStyle(theme))

const Legend = props => {
	const classes = useStyles()
	const {id, label, children, required, normalTitleColor, normalBorderColor, messageTitleColor, messageBorderColor, error, helperText} = props

	const [labelWidth, setLabelWidth] = useState(0);
	const labelRef = useRef(null);
  
	useEffect(() => {
		const labelNode = ReactDOM.findDOMNode(labelRef.current);
		setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
	}, [label])

	return (
		<Fragment>
			<Box className={classes.legendArea}>
				<Box className={classes.labelArea}>
					<InputLabel
						ref={labelRef}
						htmlFor={id}
						variant="outlined"
						shrink
						className={classes.inputLabel}
						style={{
							// '--legend-label-text': required ? error ? redColor[6] : grayColor[10] : grayColor[10]
							'--legend-label-text': required ? error ? messageTitleColor : normalTitleColor : normalTitleColor
						}} 
					>
						{label} {required ? "*" : ""}
					</InputLabel>

					<Box className={classes.outlineArea}>
						<div id={id} className={classes.content}>
							{children}
							<NotchedOutline 
								notched
								labelWidth={labelWidth}
								className={classes.outline}
								style={{
									// '--legend-border-color': required ? error ? redColor[6] : grayColor[3] : grayColor[3]
									'--legend-border-color' : required ? error ? messageBorderColor : normalBorderColor : normalBorderColor
								}} 
							/>
						</div>
					</Box>
				</Box>
			</Box>
			{
				required ? 
					error ?	<Typography variant="caption" color="error" className={classes.errorMsg}>{helperText}</Typography> : "" 
				: ""
			}

		</Fragment>
	)
}


export default Legend
